import {Stack, Typography} from '@mui/material';
import React, {Fragment} from 'react';

import {FinishWithoutCompleteFlowEnum} from 'main/analytics/gaTagsEnum';
import {AlertActions, AlertModal} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {useOdontoDuplicityDialog} from './hooks/useOdontoDuplicityDialog';
import {OdontoDuplicityDialogProps} from './types';
import {OdontoDuplicityBookedCard} from '../OdontoDuplicityBookedCard';

const {goBack, goToHome} = translations['pt-br'].commons;
const {description, headerTitle} = translations['pt-br'].privateFlow.bookingFlow.duplicityWarning;

export function OdontoDuplicityDialog({
	open,
	setOpen,
	scheduledBooking,
	isScheduleScript,
}: OdontoDuplicityDialogProps) {
	const {handleSwapSpecialty, colors, isMobile} = useOdontoDuplicityDialog({scheduledBooking});

	return (
		<AlertModal
			data-tag-id={FinishWithoutCompleteFlowEnum.POSSUI_CONSULTA_EXISTENTE_ESPECIALIDADE}
			showIcon={false}
			description={isMobile ? undefined : description}
			headerTitle={headerTitle}
			onClose={() => setOpen(false)}
			open={open}
			variant="warning"
			fullScreen={isMobile}
			footerContent={
				<AlertActions
					primaryAction={handleSwapSpecialty}
					secondaryAction={() => setOpen(false)}
					secondaryText={isScheduleScript ? goToHome : goBack}
					primaryText={headerTitle}
					flexDirection={'column-reverse'}
					secondaryBtnVariant="outlined"
					customStackProps={{bgcolor: colors.brand.primary.white, p: '8px 16px'}}
				/>
			}
			slotProps={{
				paper: {
					style: {
						maxWidth: isMobile ? '100%' : 450,
						borderRadius: isMobile ? 0 : 8,
						margin: isMobile ? 0 : 16,
						backgroundColor: isMobile ? colors.gray['20Percent'] : undefined,
					},
				},
			}}
			footerProps={{
				sx: {
					p: 0,
				},
			}}
			customContentStyles={{
				sx: {
					p: isMobile ? 0 : 3,
				},
			}}
			subDescription={
				<Fragment>
					{isMobile ? (
						<Stack sx={{bgcolor: colors.brand.primary.blue}} p={3}>
							<Typography variant="h6" color={colors.brand.primary.white}>
								{description}
							</Typography>
						</Stack>
					) : null}
					<Stack px={isMobile ? 3 : 0} width={'100%'}>
						<OdontoDuplicityBookedCard scheduledBooking={scheduledBooking} />
					</Stack>
				</Fragment>
			}
		/>
	);
}
